import {PrincipalFavoritePlaceEnum, PostFavoritePlaceRequest, PredefinedFavoritePlacesEnum} from 'domain/usecases';
import {formatMasks} from 'presentation/utils';
import {PostFavoritePlaceServiceParams} from '../types';
import {makePostFavoritePlace} from 'main/factories/usecases';

export async function postFavoritePlace({
  data,
  signal,
}: PostFavoritePlaceServiceParams) {
  const parsedData: PostFavoritePlaceRequest = {
    nmLocal: data?.favoriteAddress?.trim() ?? PredefinedFavoritePlacesEnum.OTHER,
    nmLogradouro: data.address.trim().replace(/^(\w+)\./, '$1'),
    nuEndereco: Number(data.number),
    nmBairro: data.district.trim(),
    nmCidade: data.city.trim(),
    nmUf: data.state.trim(),
    nuCep: formatMasks('clear', data.zipCode),
    flPrincipal: PrincipalFavoritePlaceEnum.NO,
    dsComplemento: data.complement.trim(),
  };
  await makePostFavoritePlace().post({...parsedData, signal});
}
